import React, {Component, lazy, Suspense} from 'react';
import {message, Select} from 'antd';
import {connect} from 'react-redux'
import cookie from "react-cookies";
import CloseIcon from '@mui/icons-material/Close';
import {Button, IconButton, Stack, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import querystring from "query-string";
import {LoadingText} from '../components/components';
import SpinLoader from '../../common/SpinLoader'
import {SAVE_STATUS} from '../../../utils/enums'
import {get, get_response, post, post_response} from '../../../helper/request'
import {urls} from '../../../utils/urls'
import {DEFAULT_DEBOUNCE, DEFAULT_RETRY} from '../../../utils/api.const'
import 'asset/style/utils/quill.css'
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import {CASE_STATUS} from "../../../const/cases_const";
import ClickAwayListener from '@mui/material/ClickAwayListener';


const ReactQuill = lazy(() => import('react-quill'));
const {Option} = Select;

class ReportApp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: this.props.slideData,
			edit: false,
			name: this.props.slideData.name,
			specimen_type: this.props.slideData.specimen_type,
			case_details: (this.props.slideData.case_details == null || this.props.slideData.case_details === "") ?
				"NIL" : this.props.slideData.case_details,
			scan_time: 0.0,
			slide_meta: {},
			slide_time: new Date(this.props.slideData.date_time),
			CAPContent: '',
			cap_map: [],
			cap_map_loaded: false,
			selectedCAP: '',
			currCase: [],
			can_edit: true,
			editing_user: '',

			save_status: SAVE_STATUS.NOT_STARTED
		};

		this.lockCapReport = this.props.abstract_configs['lockCapReport'];
		this.debounce_timeout_id = '';
		this.error_timeout_id = '';
		this.debounce_controller = null;
	}

	componentDidMount = () => {
		let url = "/api/fetch_cap_map/";
		get_response(url)
			.then(response => {
				let cap_map = response.data;
				this.setState({
					cap_map: cap_map,
					cap_map_loaded: true
				});
			})
			.catch(err => {
				console.log(err);
                this.setState({cap_map_loaded: true});
			});
		let url_ = '/api/get_slide_case_details/?case_id=' + this.props.slideData.case_id;
		if (this.props.slideData.case_id !== "" && this.props.slideData.case_id !== null) {
			get(url_)
				.then(data => {
					this.setState({
						currCase: data
					})
					this.getCAPReportEditStatus();
				})
		}
	}
    componentWillMount = () => {
        window.addEventListener("beforeunload", this.unload);
    }

    onChangeCAPContent = (value) => {
        this.setState({
            CAPContent: value
        })
    }

    handleCAPTemplateChange = (value) => {
        this.setState({
            selectedCAP: value
        })
        let template = ""
        let cap_map = this.state.cap_map
        for (let i = 0; i < cap_map.length; i++) {
	        if (cap_map[i]["search_key"] === value) {
		        console.log(this.state.currCase["report_type"])
		        if (cap_map[i]["search_key"] === this.state.currCase.cap_report_type) {
			        template = this.state.currCase.cap_report
		        } else {
			        template = this.state.cap_map[i]["template"]
			        break;
		        }
	        }
        }
	    this.setState({
		    CAPContent: template
	    })
    }

	unload = () => {
		let url = "/api/open_cap_edit/"
		let case_id = this.state.currCase.case_id
		let data = {
			'case_id': case_id,
			'user_id': parseInt(cookie.load('user_id')),
		};
		post(url, querystring.stringify(data)).then();
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (this.state.save_status !== prevState.save_status && this.state.save_status === SAVE_STATUS.ERROR) {
			this.error_timeout_id = setInterval(() => {
				if (this.debounce_controller) return
				this.saveCAPReport()
			}, DEFAULT_RETRY)
		}

		if (this.state.save_status !== SAVE_STATUS.ERROR) {
			if (this.error_timeout_id) clearInterval(this.error_timeout_id)
			this.error_timeout_id = ''
		}

		if (prevState.CAPContent === this.state.CAPContent) return

		if (this.debounce_timeout_id) clearTimeout(this.debounce_timeout_id)
		this.debounce_timeout_id = setTimeout(this.saveCAPReport, DEFAULT_DEBOUNCE)
		this.setState({save_status: SAVE_STATUS.ON_GOING})
	}

	componentWillUnmount = () => {
		this.releaseCAPEditAccess()
	}

    getCAPReportEditStatus = () => {
        let url = "/api/get_cap_edit_status/"
        let case_id = this.state.currCase.case_id
        let data = {
            'case_id': case_id,
            'user_id': parseInt(cookie.load('user_id')),
        };
        post(url, querystring.stringify(data))
            .then(resp_data => {
                    if(resp_data["can_edit"] === 0){
                        this.setState({
                            can_edit: false,
                            editing_user: resp_data["editing_user"]
                        })
                    }
                }
            );
    }

    releaseCAPEditAccess = () => {
	    let url = "/api/open_cap_edit/"
	    let case_id = this.state.currCase.case_id
	    let data = {
		    'case_id': case_id,
		    'user_id': parseInt(cookie.load('user_id')),
	    };
	    post(url, querystring.stringify(data)).then();
    }

    getOverwriteAccess = () => {
	    let url = "/api/overwrite_cap_edit/"
	    let case_id = this.state.currCase.case_id
	    let data = {
		    'case_id': case_id,
		    'user_id': parseInt(cookie.load('user_id')),
	    };
		post(url, querystring.stringify(data))
			.then(() => {
				this.getCAPReportEditStatus();
				this.setState({
					can_edit: true,
				})
			});
    }

	saveCAPReport = () => {
		const report = this.state.CAPContent
		const report_type = this.state.selectedCAP || "No Template"
		const case_id = this.state.currCase.case_id
		const data = {
			report,
			case_id,
			report_type,
			user_id: parseInt(cookie.load('user_id'))
		}

		if (this.debounce_controller) this.debounce_controller.abort()
		this.debounce_controller = new AbortController()

		post_response(
			urls.SAVE_CAP_REPORT,
			querystring.stringify(data), {
				signal: this.debounce_controller?.signal
			})
			.then(response => {
					if (parseInt(response.data['can_edit']) !== 0) return
					message.info(`Couldn't edit while ${response.data['editing_user']} is editing`)

					this.setState({
						can_edit: false,
						editing_user: response.data['editing_user']
					})
				}
			)
			.then(() => this.setState({save_status: SAVE_STATUS.COMPLETED}))
			.catch((e) => {
				this.debounce_controller = null
				if (this.debounce_timeout_id) clearTimeout(this.debounce_timeout_id)
				this.debounce_timeout_id = ''
				this.setState({save_status: SAVE_STATUS.ERROR})
			})
	}

    render() {
	    if (this.state.selectedCAP === '' && !(this.state.currCase instanceof Array)) {

		    if (this.state.currCase.cap_report_type !== '') {
			    this.setState({
				    selectedCAP: this.state.currCase.cap_report_type,
				    CAPContent: this.state.currCase.cap_report
			    })
		    }
	    }
	    let cap_report_name_options = this.state.cap_map !== undefined ?
		    this.state.cap_map.map(item => (
			    <Option key={item.search_key} value={item.search_key}>
				    {item.display_name}
			    </Option>
		    )) : undefined;

	    var toolbarOptions = [
		    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
		    ['blockquote', 'code-block'],

		    [{'header': 1}, {'header': 2}],               // custom button values
		    [{'list': 'ordered'}, {'list': 'bullet'}],
		    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
		    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
		    [{'direction': 'rtl'}],                         // text direction

		    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
		    [{'header': [1, 2, 3, 4, 5, 6, false]}],

		    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
		    [{'font': []}],
		    [{'align': []}],

		    ['clean']                                         // remove formatting button
	    ];
        let editOverrideButton;
		if ((this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED)) {
			editOverrideButton = <span style={{color: 'white'}}> The report has been locked.</span>
		} else if(this.state.can_edit){
            editOverrideButton = <span style={{color: 'green'}}> You are editing the report.</span>
        }
        else{
            editOverrideButton = <Tooltip title={`Can't edit as ${this.state.editing_user} is editing. To override click here.`} placement="top-end" >
                    <Button type="primary" color={"warning"} sx={{marginLeft: '4.5vw'}} onClick={this.getOverwriteAccess}>
                        OVERRIDE ACCESS
                    </Button>
                </Tooltip>
        }

        return (
			<ClickAwayListener onClickAway={this.props.onCAPReportClose}>
				<Stack direction={"column"} height={"100%"} spacing={1.5} padding={2}>
					<Stack direction={"row"} justifyContent={"space-between"}>
						<Typography variant={"h4"} color={"white"} align={"center"}> Report </Typography>
						<IconButton type="primary" color={"error"} onClick={this.props.onCAPReportClose}>
							<CloseIcon sx={{color: "red"}}/>
						</IconButton>
					</Stack>
					<Stack direction={"row"} justifyContent={"space-between"}>
						{!this.state.cap_map_loaded ? <LoadingText/> :
						(<Select showSearch placeholder={this.state.selectedCAP} value={this.state.selectedCAP}
							style={{width: 300}} onChange={this.handleCAPTemplateChange} loading={!this.state.cap_map_loaded}
							disabled={!this.state.can_edit || this.props.caseStatus || !hasPermissions([aclPermissions.update_cap_report]) || (this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED)}>
							{cap_report_name_options}
						</Select>)}
						{editOverrideButton}
					</Stack>
					<Stack direction={"row"} justifyContent={"space-between"}>
						<span
							style={{
								color: this.state.save_status['alpha_color'],
								'font-size': '14px',
								'font-weight': 700
							}}>
							{this.state.save_status['use_loader'] &&
								<><SpinLoader fontSize={18} color={`#ff0`}/> &nbsp;</>}

							{this.state.save_status['message_cap_report']}
						</span>
					</Stack>
					<div className="react-quill-editor-cap" style={{height: '-webkit-fill-available', overflowY: 'auto'}}>
						<Suspense fallback={<div>Loading...</div>}>
							<ReactQuill
								readOnly={!hasPermissions([aclPermissions.update_cap_report]) || (this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED)}
								modules={{
									toolbar: toolbarOptions
								}}
								theme={"snow"}
								style={{
									backgroundColor: "whitesmoke", color: "black",
								}}
								formats={[
									'header',
									'bold', 'italic', 'underline', 'strike', 'blockquote',
									'list', 'bullet', 'indent',
									'link', 'image',
									'code-block'
								]}
								bounds={'quill'}
								value={this.state.CAPContent}
								onChange={this.onChangeCAPContent}
							>
							</ReactQuill>
						</Suspense>
					</div>
				</Stack>
			</ClickAwayListener>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
		abstract_configs: state.morpheusSettingReducer.abstract_configs,
    }
}

export default connect(mapStateToProps)(ReportApp)
